import { z } from 'zod';

export const AuthMeSchema = z.object({
  CustomerID: z.string().optional(),
  PersonID: z.string().optional(),
  Roles: z.array(
    z.object({
      Name: z.string(),
      Country: z.string().optional(),
    })
  ),
  iss: z.string(),
  exp: z.number(),
  iat: z.number(),
  jti: z.string(),
});

export type AuthMe = z.infer<typeof AuthMeSchema>;
